module.exports = __webpack_public_path__ + "img/agendamento-72h.9c5d3691.svg";